<template>
  <link rel="stylesheet" href="CSS/App.css">
  <div>
    <div class="careers-header">
      <div class="show-bg-careers"></div>
    </div>
    <div class="careers-title">
      <Slide :appear="show" :transition-enter-duration="1200" :direction="right">
        <hr2 class="careers_h1" :data-column="'careers_h1'"
          v-html="BranchPage.careers_h1"></hr2>
        <p class="careers_p1" :data-column="'careers_p1'"
          v-html="BranchPage.careers_p1"></p>
        <div class="two-buttons">
          <div class="connect-with">
            <a role="button" @click="sendTo('/positions')"><KButton :size="null" :class="'custom-size1'" :theme-color="'null'"
              :rounded="'large'">Apply Now</KButton></a>
          </div>
        </div>
      </Slide>
    </div>
    <div class="white-fore"><img alt="White background" src="../assets/white-bg.png" style="border-radius: 30px;">
      <div class="h1 header">
        <hr2 class="careers_h2" :data-column="'careers_h2'" style="font-size: 1.6em; line-height: 130%">{{ BranchPage.careers_h2 }}</hr2>
      </div>
      <div class="gold-line7"></div>
      <div class="p1 header1">
        <p class="careers_p2" :data-column="'careers_p2'" v-html="BranchPage.careers_p2"
          style="font-family: sans-serif; font-weight: 100; font-size: 1.2em; line-height: 160%;"></p>
      </div>
    </div>
    <div class="careers-jobs">
      <div class="careers-jobs1">
        <img alt="Basic image of an office" :data-column="'careers_img1'" style="max-width: 300px; border-radius: 7%" :src=BranchPage.careers_img1>
        <hr2 :data-column="'careers_h3'" style="text-align: center; font-size: 2.9em">{{ BranchPage.careers_h3 }}</hr2>
        <p :data-column="'careers_p3'" style="line-height: 160%; text-align: center; padding-bottom: 5px"
          v-html="BranchPage.careers_p3"></p>
      </div>
      <div class="careers-jobs2">
        <img alt="Basic image of two people talking" :data-column="'careers_img2'" style="max-width: 300px; border-radius: 7%" :src=BranchPage.careers_img2>
        <hr2 :data-column="'careers_h4'" style="text-align: center; font-size: 2.9em">{{ BranchPage.careers_h4 }}</hr2>
        <p :data-column="'careers_p4'" style="line-height: 160%; text-align: center; padding-bottom: 5px"
          v-html="BranchPage.careers_p4"></p>
      </div>
      <div class="careers-jobs3">
        <img alt="Another image of 2 people talking" :data-column="'careers_img3'" style="max-width: 300px; border-radius: 7%" :src=BranchPage.careers_img3>
        <hr2 :data-column="'careers_h5'" style="text-align: center; font-size: 2.9em">{{ BranchPage.careers_h5 }}</hr2>
        <p :data-column="'careers_p5'" style="line-height: 160%; text-align: center; padding-bottom: 5px"
          v-html="BranchPage.careers_p5"></p>
      </div>
    </div>
    <div class="careers-contact">
      <div class="careers-centertext">
        <img alt="Image within a star" :data-column="'careers_img4'" style="max-width: 300px; margin-right: 40px" :src=BranchPage.careers_img4>
        <div class="p1 careers-submit">
          <p :data-column="'careers_p6'" style="font-size: 1.1em; line-height: 160%" v-html="BranchPage.careers_p6"></p>
        </div>
        <img alt="Goldstar star" :data-column="'careers_img5'" style="max-width: 300px;" :src=BranchPage.careers_img5>
      </div>
      <div class="h1 careers-h1">
        <hr2 :data-column="'careers_faq'" style="text-align: center; font-size: 120%">{{ BranchPage.careers_faq }}</hr2>
      </div>
      <div class="gold-line8"></div>
    </div>
    <div class="careers-faq">
      <div class="h1 career-hiring">
        <hr2 :data-column="'careers_h7'" style="font-size: 60%">{{ BranchPage.careers_h7 }}</hr2>
      </div>
      <div class="black-line2"></div>
      <details style="margin-top: 40px">
        <summary :data-column="'careers_h8'"><a role="button" onmouseover=""
            style="cursor: pointer; margin-left: 10px; font-size: 1.4em" v-html="BranchPage.careers_h8"></a></summary>
        <p :data-column="'careers_p7'" style="margin-left: 35px; line-height: 160%; font-size: 1.2em">
          {{ BranchPage.careers_p7 }}</p>
      </details>
      <details>
        <summary :data-column="'careers_h9'" style="margin-top: 40px"><a role="button" onmouseover=""
            style="cursor: pointer; margin-left: 10px; font-size: 1.4em" v-html="BranchPage.careers_h9"></a></summary>
        <p :data-column="'careers_p8'" style="margin-left: 35px; line-height: 160%; font-size: 1.2em">
          {{ BranchPage.careers_p8 }}</p>
      </details>
      <details>
        <summary :data-column="'careers_h10'" style="margin-top: 40px"><a role="button" onmouseover=""
            style="cursor: pointer; margin-left: 10px; font-size: 1.4em" v-html="BranchPage.careers_h10"></a></summary>
        <p :data-column="'careers_p9'" style="margin-left: 35px; line-height: 160%; font-size: 1.2em">
          {{ BranchPage.careers_p9 }}</p>
      </details>
      <details>
        <summary :data-column="'careers_h11'" style="margin-top: 40px"><a role="button" onmouseover=""
            style="cursor: pointer; margin-left: 10px; font-size: 1.4em" v-html="BranchPage.careers_h11"></a></summary>
        <p :data-column="'careers_p10'" style="margin-left: 35px; line-height: 160%; font-size: 1.2em">
          {{ BranchPage.careers_p10 }}</p>
      </details>
      <details>
        <summary :data-column="'careers_h12'" style="margin-top: 40px"><a role="button" onmouseover=""
            style="cursor: pointer; margin-left: 10px; font-size: 1.4em" v-html="BranchPage.careers_h12"></a></summary>
        <p :data-column="'careers_p11'" style="margin-left: 35px; line-height: 160%; font-size: 1.2em">
          {{ BranchPage.careers_p11 }}</p>
      </details>
      <div style="margin-top: 65px" class="h1 career-hiring">
        <hr2 :data-column="'careers_h13'" style="font-size: 60%">{{ BranchPage.careers_h13 }}</hr2>
      </div>
      <div class="black-line2"></div>
      <details style="margin-top: 40px">
        <summary :data-column="'careers_h14'"><a role="button" onmouseover=""
            style="cursor: pointer; margin-left: 10px; font-size: 1.4em" v-html="BranchPage.careers_h14"></a></summary>
        <p :data-column="'careers_p12'" style="margin-left: 35px; line-height: 160%; font-size: 1.2em"
          v-html="BranchPage.careers_p12"></p>
      </details>
      <details>
        <summary :data-column="'careers_h15'" style="margin-top: 40px"><a role="button" onmouseover=""
            style="cursor: pointer; margin-left: 10px; font-size: 1.4em" v-html="BranchPage.careers_h15"></a></summary>+
        <p :data-column="'careers_p13'" style="margin-left: 35px; line-height: 160%; font-size: 1.2em">
          {{ BranchPage.careers_p13 }}</p>
      </details>
      <details>
        <summary :data-column="'careers_h17'" style="margin-top: 40px"><a role="button" onmouseover=""
            style="cursor: pointer; margin-left: 10px; font-size: 1.4em" v-html="BranchPage.careers_h17"></a></summary>
        <p :data-column="'careers_p15'" style="margin-left: 35px; line-height: 160%; font-size: 1.2em">
          {{ BranchPage.careers_p15 }}</p>
      </details>
    </div>
    <div class="careers-lastsection">
      <img alt="Image within a star" :data-column="'careers_img6'" style="position: relative; margin-left: 1300px; width: 250px"
        :src=BranchPage.careers_img6>
      <div style="text-align: center; font-size: 3.8em; margin-top: -50px" class="h1 careers-header2">
        <hr2 :data-column="'careers_h18'">{{ BranchPage.careers_h18 }}</hr2>
      </div>
      <div style="text-align: center; font-size: 1.2em; margin-top: -15px" class="p1 careers-header2">
        <p :data-column="'careers_p16'">{{ BranchPage.careers_p16 }}</p>
      </div>
    </div>
    <div style="text-align: center; margin-top: 80px" class="show_bg2">
      <div class="h1 careers-header3" style="padding-top: 30px;">
        <hr2 :data-column="'careers_h19'" v-html="BranchPage.careers_h19"></hr2>
      </div>
      <div style="color: white; font-size: 1.6em; margin-top: -10px" class="p1 careers-header3">
        <p :data-column="'careers_p17'" v-html="BranchPage.careers_p17"></p>
      </div>
      <div style="justify-content: center;" class="two-buttons">
        <div class="connect-with">
          <a role="button" href="mailto:humanresources@goldstarfinancial.com"><KButton :data-column="'careers_button4'" :size="null" :class="'custom-size1'" :theme-color="'null'"
            :rounded="'large'">{{ BranchPage.careers_button4 }}</KButton></a>
        </div>
      </div>
    </div>
    <FooterComp></FooterComp>
  </div>
</template>

<script>

import '@progress/kendo-theme-default/dist/all.css';
import FooterComp from "../components/Footer_Comp.vue"
import { Button as KButton } from "@progress/kendo-vue-buttons";
import apiService from '/src/api/api.service';
import { Slide } from '@progress/kendo-vue-animation';

export default {
  name: "Careers-Page",
  components: {
    KButton,
    FooterComp,
    'Slide': Slide
  },


  data: function () {
    const searchParams = new URLSearchParams(window.location.search)
    var orgid = 'HQ';
    if(searchParams.has('org')){
      orgid = searchParams.get('org');
    }

    return {
      isVisible: false,
      show: true,
      orgid: orgid,
      BranchPage: {},
      isLoading: false,

    };
  },
  
  mounted() {
    this.GetBranchPage();
  },
  methods: {
    GetBranchPage() {
      return apiService.GetBranchPage(this.orgid)
        .then(res => {
          this.BranchPage = res.data.data[0];
          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          console.log(error)
        });
    },
    sendTo(url) {
      const searchParams = new URLSearchParams(window.location.search)
      if(searchParams.has('org')){
        window.location.href = url + '/?org=' + searchParams.get('org');
      }
      else
        window.location.href = url;
    }

  }
};
</script>

<style>
@import '/src/assets/css/careersView.css';
</style>